module.exports = __webpack_public_path__ + "img/SS_V_Gold_FA_Fighting.9bc50410.png";